export const buildAccountSettingsObj=(testType, testRequired, nbrGames, startGameTemplateArr) => {
    let gameTemplateArr = [];
    for (let i=0; i<startGameTemplateArr.length; i++){
        if (startGameTemplateArr[i].checked === true){
            gameTemplateArr.push(startGameTemplateArr[i].buttonText);
        }
    }
    let forceTest = false;
    if (testRequired === "yes"){
        forceTest = true;
    }
    const testSettings={testType: testType, forceTest: forceTest};
    const startOptions={gameTemplateArr: gameTemplateArr, nbrGames: nbrGames};
    const returnObj={testSettings: testSettings, startGameOptions: startOptions};
    return returnObj;
}
export default buildAccountSettingsObj;